import React from "react";

const SummaryCard = ({ amount, description }) => (
  <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg">
    <p className="text-lg md:text-xl font-semibold text-gray-800">{amount}</p>
    <p className="text-gray-600 mt-1">{description}</p>
  </div>
);

export default SummaryCard;
